import { createStore } from "@/hooks";
import { isEmpty, isNil } from "ramda";
import { throttle } from "@/utils";
import { getSetStore } from "@/hooks/useStore";
let findUserInfoThr: any;
const UserInfoState = createStore<Partial<defs.ucenter.SysUserResponseDto>>({});
export async function findUserInfo(): Promise<defs.ucenter.SysUserResponseDto | null> {
  if (isNil(findUserInfoThr)) {
    findUserInfoThr = throttle(API.ucenter.sysUser.info.request);
  }
  try {
    const response = await findUserInfoThr();
    if (!isEmpty(response) && !isNil(response)) {
      const { success, data }: API.ucenter.sysUser.info.Response = response;
      if (success && !isNil(data)) {
        const sensors = (window as any)["sensorsDataAnalytic201505"]; // 神策
        if (sensors) {
          sensors.login(data.email);
        }
        getSetStore(LoginInfoState)((loginInfo) => {
          return {
            ...loginInfo,
            userNo: data.userNo,
          };
        });
        return data;
      } else {
        throw new Error("查询用户信息错误");
      }
    }
    return null;
  } catch (e) {
    throw new Error("查询用户信息错误" + e);
  }
}
interface LoginInfo {
  userNo?: string | null;
  accessToken?: string | null;
}
const LoginInfoState = createStore<LoginInfo>(
  () => {
    return {
      accessToken: localStorage.getItem("rantion-erp-accessToken"),
      userNo: localStorage.getItem("rantion-erp-userNo"),
    };
  },
  {
    watch: (newState) => {
      if (newState.accessToken) {
        localStorage.setItem("rantion-erp-accessToken", newState.accessToken);
        localStorage.removeItem("reloadSession");
      } else {
        localStorage.removeItem("rantion-erp-accessToken");
        localStorage.removeItem("reloadSession");
      }
      if (newState.userNo) {
        localStorage.setItem("rantion-erp-userNo", newState.userNo);
      } else {
        localStorage.removeItem("rantion-erp-userNo");
      }
    },
  },
);

// 路由数据权限信息
export interface DataFormatter {
  [index: string]: defs.appCenter.PageViewAggregationResponseDto[] | undefined;
}
const DataPermissionState = createStore<DataFormatter>({});
export { UserInfoState, LoginInfoState, DataPermissionState };
